enum ApiAggregationTypes {
  CUSTOMER_BIRTH_YEARS = 'CustomerBirthYears',
}

export default ApiAggregationTypes;
